import { styled } from "@mui/material";

export const Title = styled("span")`
  color: ${({ theme }) => theme.palette.primary.light};
  font-weight: 600;
  margin-right: 0.5rem;
`;
